/**
 * ResolvedDashboardLayout — picks v1 or v2 shell based on the rebirth flag.
 *
 * This is the §5.3 "shell + page composition rule" from
 * Agentlets-Implementation-Plan.md:
 *
 *   if (flag('ui.rebirth.shell.v2', user)) <DashboardLayoutV2/> else <DashboardLayout/>
 *
 * Per-page v2 flags (rebirth.overview.v2, etc.) are evaluated *inside*
 * the page slot, NOT here — keeping the shell-vs-page decisions
 * orthogonal. A user with the shell flag on but the overview flag off
 * gets v2 chrome wrapping the v1 OverviewPage. That's intentional and
 * lets us roll out chrome and pages independently.
 *
 * Reads the flag at render time so a SuperAdmin can toggle from /flags
 * without an app restart (a single page reload re-evaluates).
 */
import React from 'react';
import DashboardLayout from './DashboardLayout';
import DashboardLayoutV2 from './DashboardLayoutV2';
import { isRebirthShellEnabled } from '../utils/featureFlags';

export default function ResolvedDashboardLayout({ children }) {
  if (isRebirthShellEnabled()) {
    return <DashboardLayoutV2>{children}</DashboardLayoutV2>;
  }
  return <DashboardLayout>{children}</DashboardLayout>;
}
